import { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import ProfileCard from "./ProfileCard";
import FloatingLabelInput from "../Generic/FloatingLabelInput";

const ProfileAboutSection = ({
  form,
  setForm,
  updateProfileSection,
  validateSection,
  readOnly,
}) => {
  const [editing, setEditing] = useState(false);

  const saveAbout = async () => {
    if (!validateSection("about", form)) return;
    await updateProfileSection({
      bio: form.bio,
      industries: form.industries,
      skills: form.skills.map((s) => ({ skill: s })),
    });
    setEditing(false);
  };

  const updateSkill = (index, value) => {
    const updated = [...form.skills];
    updated[index] = value;
    setForm((p) => ({ ...p, skills: updated }));
  };

  const addSkill = () => {
    setForm((p) => ({ ...p, skills: [...p.skills, ""] }));
  };

  const removeSkill = (index) => {
    setForm((p) => ({
      ...p,
      skills: p.skills.filter((_, i) => i !== index),
    }));
  };

  return (
    <ProfileCard
      title="About"
      isEditing={editing}
      onEdit={() => setEditing(true)}
      onSave={saveAbout}
      onCancel={() => setEditing(false)}
      readOnly={readOnly}
    >
      {/* VIEW MODE */}
      {!editing ? (
        <>
          <p>
            <strong>Bio:</strong> {form.bio || "Not added"}
          </p>

          <p>
            <strong>Industries:</strong> {form.industries || "Not added"}
          </p>

          <p>
            <strong>Skills:</strong>
          </p>

          {form.skills?.length > 0 ? (
            <div className="chips-row">
              {form.skills.map((s, idx) => (
                <span key={idx} className="chip">
                  {s}
                </span>
              ))}
            </div>
          ) : (
            <p className="text-muted">Not added</p>
          )}
        </>
      ) : (
        /* EDIT MODE */
        <>
          {/* Bio */}
          <div className="floating-label-container mb-3">
            <Form.Control
              as="textarea"
              rows={3}
              className="floating-input"
              placeholder=" "
              value={form.bio || ""}
              onChange={(e) => setForm((p) => ({ ...p, bio: e.target.value }))}
              style={{ background: "white" }}
            />
            <label
              className={`floating-label ${form.bio ? "active" : ""}`}
            ></label>
          </div>

          {/* Industries */}
          <div className="mb-3">
            <FloatingLabelInput
              label="Industries (comma separated)"
              type="text"
              value={form.industries || ""}
              onChange={(e) =>
                setForm((p) => ({ ...p, industries: e.target.value }))
              }
            />
          </div>

          <div className="mb-2">
            <strong>Skills</strong>
          </div>

          {/* Skills */}
          <Row>
            {(form.skills.length > 0 ? form.skills : [""]).map((s, idx) => (
              <Col md={6} sm={12} key={idx} className="mb-2">
                <div className="d-flex align-items-center">
                  <div style={{ flex: 1 }}>
                    <FloatingLabelInput
                      label="Enter a skill"
                      type="text"
                      value={s}
                      onChange={(e) => updateSkill(idx, e.target.value)}
                    />
                  </div>
                  {form.skills.length > 0 && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="ms-2"
                      onClick={() => removeSkill(idx)}
                    >
                      ×
                    </Button>
                  )}
                </div>
              </Col>
            ))}
          </Row>

          <Button variant="outline-primary" size="sm" onClick={addSkill}>
            + Add Skill
          </Button>
        </>
      )}
    </ProfileCard>
  );
};

export default ProfileAboutSection;
